import React from "react";
import { EBButtonV2 } from "../components/common/EBButtonV2";
import { TextViewComponent } from "../components/common/TextView";
import { RawContent } from "./RawContent.Model";

interface RawContentListItemProps {
  rawContent: RawContent;
  onDelete: (id: number) => void;
  onEdit: (rawContent: RawContent) => void;
  onRequeue: (id: number) => void;
}

export function RawContentListItem({
  rawContent,
  onDelete,
  onEdit,
  onRequeue,
}: RawContentListItemProps) {
  return (
    <div>
      <div>
        <strong>ID:</strong> {rawContent.id}
      </div>
      <div>
        <strong>Content:</strong>{" "}
        <TextViewComponent
          text={rawContent.content}
          maxLength={200}
          showMoreButton={true}
          showCopyButton={true}
        />
      </div>
      <div>
        <strong>Source:</strong>{" "}
        <TextViewComponent
          text={rawContent.source}
          maxLength={100}
          showMoreButton={true}
        />
      </div>
      <div>
        <strong>Use Case:</strong> {rawContent.useCase}
      </div>
      <div>
        <strong>Status:</strong> {rawContent.status}
      </div>
      <div>
        <strong>Created At:</strong>{" "}
        {new Date(rawContent.createdAt).toLocaleString()}
      </div>
      <div>
        <strong>Updated At:</strong>{" "}
        {new Date(rawContent.updatedAt).toLocaleString()}
      </div>
      <div style={{ display: "flex", gap: "8px" }}>
        <EBButtonV2
          onClick={() => onEdit(rawContent)}
          content={{ normal: "Edit" }}
        />
        <EBButtonV2
          onClick={() => onDelete(rawContent.id)}
          content={{ normal: "Delete" }}
        />
        {rawContent.status === "FAILED" && (
          <EBButtonV2
            onClick={() => onRequeue(rawContent.id)}
            content={{ normal: "Requeue" }}
          />
        )}
      </div>
    </div>
  );
}
